let sequence = 0

// Every tab of a user shares one preview channel, so the id has to be unique across tabs too:
// the sequence separates requests within a tab and the random suffix separates tabs.
export function createPreviewRequestId() {
  sequence += 1
  return `${Date.now().toString(36)}-${sequence.toString(36)}-${Math.random()
    .toString(36)
    .slice(2, 8)}`
}
